import { useEffect, useState } from "react";
import { CartItem } from "../../components/CartItem";
import { MainButton } from "../../components/MainButton";
import { Menu } from "../../components/Menu";
import { MiniHeader } from "../../components/MiniHeader";
import { AddressMapType, ModalDelivery } from "../../components/ModalDelivery";
import { ModalWithdrawal } from "../../components/ModalWithdrawal";
import {
  centsToFloat,
  floatToCents,
  floatToPercent,
  floatToPrice,
} from "../../functions/price_functions";
import { useOrder } from "../../hooks/useOrder";
import InputMask from "react-input-mask";

import { useAppConfig } from "../../hooks/useAppConfig";
import { Loading } from "../../components/Loading";
import { ConfigType } from "../../contexts/AppConfigContext";
import "./index.css";
import { ModalSellerSave } from "../../components/ModalSellerSave";
import { useSeller } from "../../hooks/useSeller";
import api from "../../services/api";
import {
  MeasureType,
  OrderToSendType,
  OrderType,
  ProductType,
} from "../../contexts/OrderContext";
import { cepNoMask, cpfCnpjNoMask } from "../../functions/mask";
import Swal from "sweetalert2";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useNavigate, useParams } from "react-router-dom";
import { ModalTableSave } from "../../components/ModalTableSave";
import { v4 as uuidv4 } from "uuid";
import { Input } from "../../components/Input/Input";
import { ModalEditFreight } from "../../components/ModalEditFreight";
import useAuth from "../../hooks/useAuth";
import { SellerOrder } from "../SellerOrders";
import { useFoodConfig } from "../../hooks/useFood";
import { FoodCashbackSection } from "../../components/FoodCashbackSection/FoodCashbackSection";
import { PiMagnifyingGlass } from "react-icons/pi";
import { useFaceBookPixel } from "../../hooks/useFacebookPixel";
import { useFoodCartVisibilityValidation } from "../../hooks/useFoodCartVisibilityValidation";
import { ComandaCart } from "../ComandaCart/index"; // ajuste o caminho se necessário

type ProductCartType = {
  id: number;
  img: string;
  sku: string;
  variation: any;
  name: string;
  price: number;
  unitPrice: number;
  discount: number;
  discountGeral: number;
  promotional_price: number;
  quantity: number;
  code: string;
  sku_info: Array<{
    vendas: number;
    inventory: number;
    minimum_stock: number;
    measures: MeasureType;
  }>;
};

type StoresType = {
  id: number;
  name: string;
  city: string;
  district: string;
  street: string;
  number: string;
  currentBalance: number;
  distance: string;
  locationId?: number;
  sku?: string;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

type LocationType = {
  id: number;
  name: string;
  code: string;
  status: boolean;
  type: string;
  cep: string;
  address: AddressLocationType | null;
};

type PluginconfigType = {
  id: number;
  pluginspaceId: number;
  plugintypeId: number;
  plugintemplateId: {
    id: number;
    name: string;
  };
  name: string;
  content: any;
};

type ProductTotvsType = {
  id: number;
  chair: string;
  image: string;
  stock: number;
  codFilial: string | null;
  code: string;
  discount: number;
  productName: string;
  hash: string;
  info: string;
  notes: string;
  price: number;
  productSku: string;
  quantity: number;
  unitPrice: number;
  locationId: number;
  variation: Array<{
    grid: string;
    value: string;
  }>;
};

type NinegridMotorConfig = {
  able: number;
  codigoEstabelecimento: number;
  maxMonetary: number;
  maxPercentage: number;
  typeDiscount: number;
};

type ItemEmptyType = {
  id: string;
  locationId: number;
  pluginspaceId: number;
  status: boolean;
  sku: string;
  price: number;
  inventory: number;
  minimumStock: number;
  promotionalPrice: number;
  name: string;
  currentBalance: number;
};

type MapLocationType = {
  longitude: number;
  latitude: number;
};

export function Cart() {
  const navigate = useNavigate();
  const orderContext = useOrder();
  const {
    changeCustomerAdressByCartPage,
    customerAdress,
    getCustomerAdress,
    setType,
    setOrderAddress,
    setLocationId,
  } = useOrder();
  const { trackInitiateCheckout } = useFaceBookPixel();
  const { validateAndCleanCart } = useFoodCartVisibilityValidation();
  const { pluginspace_id } = useParams();
  const {
    getToken,
    pluginspaceData,
    registerAccess,
    getThisPluginspace,
    getLocations,
  } = usePluginspace();
  const [cep, setCep] = useState("");
  const [cepAlarm, setCepAlarm] = useState(false);
  const [findCep, setFindCep] = useState(false);
  const [freightFind, setFreightFind] = useState(0);
  const [typeFreight, setTypeFreight] = useState("withdraw");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { getAppConfig, getSellerAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);
  const [canWithdraw, setCanWithdraw] = useState(false);

  const [isSeller, setIsSeller] = useState(false);
  const [sellerModalIsOpen, setSellerModalIsOpen] = useState(false);
  const [valueCep, setValueCep] = useState(0);
  const [stores, setStores] = useState<Array<StoresType>>([]);
  const [productStores, setProductStores] = useState<Array<StoresType>>([]);
  const [locations, setLocations] = useState<Array<LocationType>>([]);
  const { getTokenSeller } = useSeller();

  const [order, setOrder] = useState<OrderType>();
  const [orderBackUp, setOrderBackUp] = useState<OrderType>();
  const [total, setTotal] = useState(0);
  const [totalWithoutDiscount, setTotalWithoutDiscount] = useState(0);

  const [hideMenu, setHideMenu] = useState(false);

  const [isCard, setIsCard] = useState(false);
  const [isTable, setIsTable] = useState(false);
  const [isLandmark, setIsLandmark] = useState(false);
  const [isPluginbot, setIsPluginbot] = useState(false);
  const [isCounter, setIsCounter] = useState(false);
  const [isInternalDelivery, setIsInternalDelivery] = useState(false);
  const [tableModalIsOpen, setTableModalIsOpen] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [totvsVarejoAble, setTotvsVarejoAble] = useState(false);
  const [totvsMotorAble, setTotvsMotorAble] = useState(false);
  const [typePluginspace, setTypePluginspace] = useState("");

  const [ninegridMotorAble, setNinegridMotorAble] = useState(false);
  const [ninegridMotorConfig, setNinegridMotorConfig] =
    useState<NinegridMotorConfig>();

  const [valueWithDraw, setValueWithDraw] = useState(0);

  const [minimumValue, setMinimumValue] = useState(0);

  //descontos
  const [descontoMonetario, setDescontoMonetario] = useState("0");
  const [descontoPercent, setDescontoPercent] = useState("0");

  const [allowDiscountSeller, setAllowDiscountSeller] = useState(false);
  const [maxDiscountSeller, setMaxDiscountSeller] = useState(0);

  const [discountType, setDiscountType] = useState(0);

  //modal de editar frete
  const [modalEditFreight, setModalEditFreight] = useState(false);

  //Tipo de Desconto Geral ou Vendedor
  const [geralDiscount, setGeralDiscount] = useState(false);

  //Limites de desconto monetario e porcentagem

  const [monetaryDiscountMax, setMonetaryDiscountMax] = useState(0);
  const [percentyDiscountMax, setPercentyDiscountMax] = useState(0);

  const [validShift, setValidShift] = useState(true);

  //Se está logado ou não
  const [login, setLogin] = useState(false);

  const [loadingHeader, setLoadingHeader] = useState(true);

  const [position, setPosition] = useState({ latitude: 0, longitude: 0 });

  const [addressMapLocation, setAddressMapLocation] =
    useState<AddressMapType | null>(null);

  const { loginInfo } = useAuth();

  //pediddo auxi para o carrinho do vendedor usado como auxilio
  const [orderSellerAux, setOrderSellerAux] = useState<OrderType>();

  const {
    clearOrder,
    generateDataToSendOrderCard,
    setReceipt,
    setOrderId,
    setOrderIdExt,
  } = useOrder();

  const { setTypeModal, setOpenModal } = useFoodConfig();

  useEffect(() => {
    registerAccess("cart");
    loadAll();
  }, []);

  useEffect(() => {
    !isSeller && loadOrder();
  }, [orderContext]);

  async function findCustomer(cpfOrCnpj: string) {
    const cpfWithouthMask = cpfCnpjNoMask(cpfOrCnpj);

    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const customerAddresses = response.data.data[0].customerAddresses;
          orderContext.changeCustomerDocument(cpfOrCnpj);
          if (customerAddresses.length > 0) {
            setCep(customerAddresses[0].zipCode);
            orderContext.changeCustomerAdressByCartPage(
              customerAddresses[0].zipCode,
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function loadAll() {
    setLoading(true);

    const tk = getTokenSeller();
    if (tk && tk.profile == "seller") {
      setIsSeller(true);
      await getSeller(tk.id);
      await getSellerConfig();
    } else {
      await getConfig();
    }

    await getVerifyShift();
    await verifyTotvs();
    await verifyNinegridProm();

    //usado para verificar se deve ou não criar um carrinho ou atualizar
    await orderContext.getshouldUpdadeCart();
    await orderContext.getGuidCartNew();

    await loadOrder();

    const newOrder = await orderContext.getOrder();
    const newProducts = newOrder.products.filter((product) => !product.orderId);
    newOrder.products = newProducts;
    await orderContext.setProductsOrder(newProducts);
    setOrder(newOrder);
    setOrderSellerAux(newOrder);

    const loc = await getLocations();

    setLocations(loc);

    const pgData = await getThisPluginspace();
    if (pgData && pgData.type) {
      setTypePluginspace(pgData.type);
    }

    if (window.location.search && window.location.search !== "") {
      const guidCart = window.location.search.split("=")[1];
      await getCart(guidCart);

      const customer = await orderContext.getCustomer();

      const documento = await orderContext.getCustomerDocument();
      if (documento) await findCustomer(documento);
    }

    // Setando as flags de tipo de pedido
    setIsLandmark(!!getLandmark());
    setIsPluginbot(!!getLandmarkPluginbot());
    setIsInternalDelivery(!!getInternalDelivery());
    setIsCounter(!!getCounterNumber());
    setIsCard(!!getCardNumber());
    setIsTable(!!getTableNumber());

    loginInfo.accessToken != "" ? setLogin(true) : setLogin(false);

    const cA = await getCustomerAdress();

    if (cA) {
      setCep(cA.cep);
    }

    if (pgData && pgData.type === "food") {
      await validateAndCleanCart();
      await refreshOrderFromContext();
    }

    setTimeout(() => {
      setLoading(false);
    }, 0);
  }

  async function verifyTotvs() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 15,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const configData: PluginconfigType = response.data.data[0];

          if (configData.content.able === "1") {
            setTotvsVarejoAble(true);
            if (configData.content.habilitarMotorPromocao === "1") {
              setTotvsMotorAble(true);
              if (orderContext.order) {
                const productsCart: ProductType[] =
                  orderContext.order?.products.map((product) => {
                    product.promotionalPrice = product.unitPrice;
                    return product;
                  });
                setOrder({
                  products: productsCart,
                });
                await orderContext.changeOrderByGuidCart(
                  productsCart,
                  orderContext,
                );
              }
              orderContext.setDiscountGeneral(0);
              await orderContext.totalValueOrder();
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //verificação do motor de promoção ninegrid
  async function verifyNinegridProm() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 107,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const configData: PluginconfigType = response.data.data[0];
          if (configData.content.able === "1") {
            setNinegridMotorAble(true);
            setNinegridMotorConfig(configData.content);

            setGeralDiscount(
              configData.content.typeDiscount == 0 ? true : false,
            );

            setMonetaryDiscountMax(parseFloat(configData.content.maxMonetary));
            setPercentyDiscountMax(
              parseFloat(configData.content.maxPercentage),
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function loadOrder() {
    const totalValues = await orderContext.totalValueOrder(true);
    setTotal(totalValues.total);
    setTotalWithoutDiscount(totalValues.totalWithoutDiscount);
  }

  async function refreshOrderFromContext() {
    const updatedOrder = await orderContext.getOrder();
    setOrder(updatedOrder);
    await loadOrder();
  }

  // Função que retorna o carrinho do cliente (Criado pelo vendedor)
  async function getCart(guid: string) {
    await api
      .get(`/api/customerCart/guid/${guid}`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const order = response.data.data[0];

        const config = await getAppConfig();

        const carrinhoDataCriacao = new Date(order.created);
        const now = new Date(); // Data e hora atuais

        const hour = config
          ? config.content.pdv.sellerCartExpirationTime.split(":")[0]
          : "2";
        const minute = config
          ? config?.content.pdv.sellerCartExpirationTime.split(":")[1]
          : "0";

        const validTimeCart = new Date(
          carrinhoDataCriacao.getFullYear(),
          carrinhoDataCriacao.getMonth(),
          carrinhoDataCriacao.getDate(),
          carrinhoDataCriacao.getHours() + parseInt(hour),
          carrinhoDataCriacao.getMinutes() + parseInt(minute),
        );

        if (now > validTimeCart) {
          Swal.fire({
            icon: "warning",
            titleText: "Carrinho expirado",
            text: "O carrinho do vendedor está expirado. Favor entrar em contato com o seu vendedor",
          });
          return;
        }

        if (
          response.data.data &&
          response.data.data[0] &&
          response.data.data[0].cpfSeller
        ) {
          orderContext.setSellerCpfCnpj(response.data.data[0].cpfSeller);
        }
        orderContext.setCustomer({
          name: order.customerName,
          telephone: order.phoneCustomer,
          cpf: order.cpfCustomer,
        });

        orderContext.setGuidCart(guid);

        orderContext.changeCustomerDocument(order.cpfCustomer);

        let productsCart: any = [];

        if (order.jsonCart.products) {
          productsCart = order.jsonCart.products.map(
            (product: ProductCartType) => {
              const variationFormated: any = {};
              product.variation.map((variation: any) => {
                variationFormated[variation.grid] = variation.value
                  ? variation.value
                  : variation.valor;
              });
              const newProduct: ProductType = {
                id: product.id,
                image: product.img,
                code: product.code,
                locationId: order.locationId,
                name: product.name,
                promotionalPrice: product.promotional_price,
                quantity: product.quantity,
                sku: product.sku,
                stock: product.sku_info[0].inventory,
                unitPrice: product.unitPrice,
                variation: variationFormated,
                pluginspaceHash: pluginspace_id ? pluginspace_id : "",
                outStock: false,
                measures: product.sku_info[0].measures
                  ? product.sku_info[0].measures
                  : null,
              };
              return newProduct;
            },
          );
        } else {
          productsCart = order.jsonCart.map((product: ProductCartType) => {
            const variationFormated: any = {};
            product.variation.map((variation: any) => {
              variationFormated[variation.grid] = variation.value
                ? variation.value
                : variation.valor;
            });
            const newProduct: ProductType = {
              id: product.id,
              image: product.img,
              code: product.code,
              locationId: order.locationId,
              name: product.name,
              promotionalPrice: product.promotional_price,
              quantity: product.quantity,
              sku: product.sku,
              stock: product.sku_info[0].inventory,
              unitPrice: product.unitPrice,
              variation: variationFormated,
              pluginspaceHash: pluginspace_id ? pluginspace_id : "",
              outStock: false,
              measures: product.sku_info[0].measures
                ? product.sku_info[0].measures
                : null,
            };
            return newProduct;
          });
        }

        setOrder({
          products: productsCart,
        });
        await orderContext.changeOrderByGuidCart(productsCart, orderContext);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getConfig() {
    setLoadingHeader(true);
    const config = await getAppConfig();
    setLoadingHeader(false);
    setMinimumValue(config!.content.pdv.minimumValue);

    setConfig(config);
  }

  async function getSellerConfig() {
    setLoadingHeader(true);
    const config = await getSellerAppConfig();
    setMinimumValue(config!.content.pdv.minimumValue);

    setConfig(config);

    setLoadingHeader(false);
  }

  async function chooseAddress() {
    if (typePluginspace === "food") {
      const isCartValid = await validateAndCleanCart();
      if (!isCartValid) {
        await refreshOrderFromContext();
        return;
      }
    }

    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      await Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue,
        )}`,
      });
      return;
    }
    const locationType = locations.find((loc) => typeFreight === loc.code);
    if (locationType) {
      const storeOutStock: StoresType | undefined = productStores.find(
        (str) => str.locationId === locationType.id && str.currentBalance <= 0,
      );
      if (storeOutStock && !(config && config.content.pdv.showOutStock)) {
        const prodFinded: ProductType | undefined = order?.products.find(
          (prod) => prod.sku === storeOutStock.sku,
        );
        if (prodFinded) {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: `Produto: ${prodFinded.name} sem estoque`,
          });
          return;
        }
      }
    }
    orderContext.setFreight(freightFind);
    setModalIsOpen(true);
  }

  async function findCepDelivery(cepSended?: string) {
    const noMaskCep = cepNoMask(cepSended ? cepSended : cep);

    if (config) {
      const value = config!.content.pdv.withDrawFee
        ? parseFloat(config!.content.pdv.withDrawFee.toString())
        : 0;

      setValueWithDraw(value);
      setFreightFind(value);
    }
    setLoading(true);
    let urlSearchValid = "";
    switch (config?.content.pdv.restrictCep) {
      case "cep":
        urlSearchValid = `/api/zip-code/valid/${noMaskCep}`;
        break;
      case "area":
        urlSearchValid = `/api/delivery/valid/${noMaskCep}`;
        break;
      case "mapa":
        urlSearchValid = `/api/delivery-area/valid/${noMaskCep}`;
        break;
      default:
        urlSearchValid = `/api/zip-code/valid/${noMaskCep}`;
        break;
    }
    await api
      .get(urlSearchValid, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const findedCeps = response.data.data;

        if (findedCeps.length > 0 && findedCeps[0].valor >= 0) {
          setFindCep(true);
          setValueCep(findedCeps[0].valor);
        } else {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: "Não foi possível encontrar formas de envio para o CEP",
          });

          setFindCep(false);
          setCanWithdraw(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        setFindCep(false);
        setCanWithdraw(false);
        console.log(err);
        setLoading(false);
      });
  }

  async function validCep(cep: string) {
    return await api
      .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
      .then((response) => {
        if (response.data.erro) {
          return false;
        }
        return true;
      })
      .catch(() => {
        return false;
      });
  }

  function validatePurchaseMin() {
    return total >= minimumValue ? true : false;
  }

  async function setDiscount() {
    if (discountType == 0) {
      if (parseFloat(descontoMonetario) == 0) {
        const totalValues = await orderContext.totalValueOrder();
        setOrder(orderSellerAux);
        setTotal(totalValues.total);
      } else {
        if (monetaryDiscountMax < parseFloat(descontoMonetario)) {
          Swal.fire({
            icon: "warning",
            titleText: "Desconto inválido",
            text: "Não pode aplicar desconto maior que o configurado",
          });
          await zerarDiscount();
          return;
        }

        const totalValues = await orderContext.totalValueOrder();

        if (totalValues.total - parseFloat(descontoMonetario) <= 0) {
          Swal.fire({
            icon: "warning",
            titleText: "Desconto inválido",
            text: "O desconto não pode ser maior que o valor da compra",
          });
          await zerarDiscount();
          return;
        }
        setTotal(totalValues.total - parseFloat(descontoMonetario));
      }
    } else {
      if (descontoPercent == "0") {
        const totalValues = await orderContext.totalValueOrder();
        setOrder(orderSellerAux);
        setTotal(totalValues.total);
      } else {
        const maxPercentDiscout = geralDiscount
          ? percentyDiscountMax
          : maxDiscountSeller;

        if (maxPercentDiscout < parseFloat(descontoPercent)) {
          Swal.fire({
            icon: "warning",
            titleText: "Desconto inválido",
            text: "Não pode aplicar desconto maior que o configurado",
          });
          await zerarDiscount();
          return;
        }

        const totalValues = await orderContext.totalValueOrder();

        setTotal(totalValues.total);
        const value = (
          (totalValues.total * parseFloat(descontoPercent)) /
          100
        ).toFixed(2);

        if (totalValues.total - parseFloat(value) <= 0) {
          Swal.fire({
            icon: "warning",
            titleText: "Desconto inválido",
            text: "O desconto não pode ser maior que o valor da compra",
          });
          await zerarDiscount();
          return;
        }
        setTotal(totalValues.total - parseFloat(value));
      }
    }
  }

  async function zerarDiscount() {
    const totalValues = await orderContext.totalValueOrder();
    orderContext.setDiscountGeneral(0);

    setTotal(totalValues.total);
    setDescontoMonetario("0");
    setDescontoPercent("0");
  }

  //Caso for um vendedor busque as informações dele
  async function getSeller(id: any) {
    await api
      .get(`/api/users/${id}`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        if (response.status === 200) {
          const data = response.data;
          var regexPattern = new RegExp("true");
          if (data && data.content) {
            const content = JSON.parse(data.content);

            setAllowDiscountSeller(
              content.allow_discount
                ? regexPattern.test(content.allow_discount)
                : false,
            );
            setMaxDiscountSeller(
              content.discount_value ? parseFloat(content.discount_value) : 0,
            );
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //Nessa Função ocorre a validação do cep e depois a busca pra saber se é valido ou não para a loja
  async function getStores(cepSended?: string, latLng?: MapLocationType) {
    if (order && order.products.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: "Não existem produtos no carrinho",
      });

      return;
    }

    const cepUse = cepSended ? cepSended : cep;
    if (cepUse.includes("_____-___")) {
      return;
    }
    setLoading(true);
    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      setLoading(false);
      setTimeout(function () {
        Swal.fire({
          icon: "warning",
          title: "Atenção",
          text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
            minimumValue,
          )}`,
        });
      }, 10);
      return;
    }

    const cepOk = cepSended ? true : await validCep(cepUse);
    if (!cepOk) {
      setLoading(false);
      setStores([]);
      Swal.fire({
        icon: "warning",
        title: "CEP inválido!",
        text: "Verifique se o CEP foi digitado corretamente",
      });
      return;
    }
    const noMaskCep = cepNoMask(cepUse);
    const orderSave = await orderContext.getOrder();

    const skus: Array<String> | undefined = orderSave.products.map(
      (prod) => prod.sku,
    );
    const pgData = await getThisPluginspace();

    /*
			variavel para verificar se ha a necessidade de pesquisar novamente os 
			estoques do produto. Funciona somente se a pluginSpace for FOOD
		
		*/

    const orderBackUp = await orderContext.getOrderToVerify();

    if (orderBackUp) {
      let shouldSearchAgain = false;
      const skusToVerify: Array<String> | undefined = [];
      const prodsToVerify: Array<ProductType> | undefined = [];

      orderSave.products.forEach((produto) => {
        const productVerify = orderBackUp.products.find(
          (prod) => prod.sku === produto.sku,
        );

        if (productVerify) {
          if (produto.quantity > productVerify.quantity) {
            shouldSearchAgain = true;
            skusToVerify.push(produto.sku);
            prodsToVerify.push(produto);
          }
        } else {
          skusToVerify.push(produto.sku);
          prodsToVerify.push(produto);
          shouldSearchAgain = true;
        }
      });

      if (shouldSearchAgain) {
        await api
          .post(
            `/api/variations/skuzipcode`,
            {
              zipcode: noMaskCep,
              skus: skusToVerify ? skusToVerify : [],
              restrictCep: config?.content.pdv.restrictCep
                ? config?.content.pdv.restrictCep
                : "cep",
              noVerifyStock: true,
              locationId: locations.find((el) => el.type == "internal")?.id
                ? locations.find((el) => el.type == "internal")?.id
                : null,
              latLng: latLng ? latLng : null,
            },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            },
          )
          .then(async (response) => {
            let newStores: Array<StoresType> = [];

            if (!response.data || response.data.success === false) {
              setLoading(false);
              //Fazer um for para mostrar todos os produtos e mostrar na tela
              if (response.data.dataEmpty) {
                const ids = response.data.dataEmpty.map(
                  (prod: any) => prod.sku,
                );
                const filtered = response.data.dataEmpty.filter(
                  (prod: any, index: number) =>
                    !ids.includes(prod.sku, index + 1),
                );

                Swal.fire({
                  icon: "warning",
                  title: "Atenção!",
                  text:
                    response.data.dataEmpty &&
                    response.data.dataEmpty.length > 0
                      ? `Produtos: ${filtered
                          .map((u: any) => u.name)
                          .join(", ")} sem estoque`
                      : "Não foi possível encontrar formas de envio para o CEP.",
                });
                const newProducts = orderSave.products.map((produto) => {
                  if (ids.includes(produto.sku)) produto.outStock = true;
                  return produto;
                });
                setOrder({
                  products: newProducts,
                });
              } else {
                const filtered: any = [];
                Swal.fire({
                  icon: "warning",
                  title: "Atenção!",
                  text:
                    response.data.dataEmpty &&
                    response.data.dataEmpty.length > 0
                      ? `Produtos: ${filtered
                          .map((u: any) => u.name)
                          .join(", ")} sem estoque`
                      : "Não foi possível encontrar formas de envio para o CEP.",
                });
              }

              setCanWithdraw(false);
              setStores([]);
              setFindCep(false);
              return;
            }
            //Fazer validação dos produtos desativados no retorno ;

            // comparar sku enviado com os retornados.
            // const ids = response.data.map((prod: any) => prod.sku);
            // const filtered = response.data.filter((prod: any, index: number) => !ids.includes(prod.sku, index + 1));
            // let doesNotexists = skusToVerify.map((skus: any) => {
            // 	const find = filtered.find((prod: any) => prod.sku === skus)

            // 	if (!find) {
            // 		return skus
            // 	}
            // })

            // doesNotexists = doesNotexists.filter((skus: any) => skus !== undefined);

            // if (doesNotexists.length > 0) {

            // 	const produtos = doesNotexists.map((skus: any) => {

            // 		const find = orderSave.products.find((prod: any) => prod.sku === skus)

            // 		return find!.name

            // 	})

            // 	setLoading(false)
            // 	Swal.fire({
            // 		icon: "warning",
            // 		title: 'Atenção!',
            // 		text: (response.data.dataEmpty && response.data.dataEmpty.length > 0) ?
            // 			`Produtos: ${filtered.map((u: any) => u.name).join(', ')} sem estoque`
            // 			: 'Não foi possível encontrar formas de envio para o CEP.'

            // 	});
            // 	let skusEmpty = response.data.dataEmpty.map((item: ItemEmptyType) => item.sku)
            // 	const newProducts = orderSave.products.map(produto => {
            // 		if (skusEmpty.includes(produto.sku)) produto.outStock = true;
            // 		return produto
            // 	})
            // 	setOrder({
            // 		products: newProducts
            // 	})
            // 	setCanWithdraw(false);
            // 	setStores([]);
            // 	setFindCep(false);
            // 	return

            // }

            setProductStores(response.data);
            response.data.map((str: StoresType) => {
              const newStore = {
                id: str.id,
                name: str.name,
                city: str.city,
                district: str.district,
                street: str.street,
                number: str.number,
                distance: str.distance,
                currentBalance: str.currentBalance,
              };
              const findedStore = newStores.find(
                (findStore) =>
                  findStore.name === newStore.name &&
                  findStore.distance === newStore.distance,
              );
              if (!findedStore) {
                newStores.push(newStore);
                localStorage.setItem("storeAddress", JSON.stringify(newStore));
              }
            });
            setCanWithdraw(true);
            await findCepAdress(noMaskCep);
            cepSended
              ? await findCepDelivery(cepSended)
              : await findCepDelivery();

            setStores(newStores);
            if (typeFreight === "delivery" && valueCep) {
              setFreightFind(valueCep);
            }
            setLoading(false);

            orderContext.setOrderToVerify(orderSave);
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
            Swal.fire({
              icon: "warning",
              title: "Erro!",
              text: "Falha ao buscar CEP",
            });
          });
      } else {
        //verificação la loja, para adicionar como opção
        const localStore = localStorage.getItem("storeAddress");

        if (localStore) {
          const locations = JSON.parse(localStore);

          setStores([locations]);
        }

        setCanWithdraw(true);
        await findCepAdress(noMaskCep);
        cepSended ? await findCepDelivery(cepSended) : await findCepDelivery();
        if (typeFreight === "delivery" && valueCep) {
          setFreightFind(valueCep);
        }
        setLoading(false);
      }
    } else {
      await api
        .post(
          `/api/variations/skuzipcode`,
          {
            zipcode: noMaskCep,
            skus: skus ? skus : [],
            restrictCep: config?.content.pdv.restrictCep
              ? config?.content.pdv.restrictCep
              : "cep",
            noVerifyStock: true,
            locationId: locations.find((el) => el.type == "internal")?.id
              ? locations.find((el) => el.type == "internal")?.id
              : null,
            latLng: latLng ? latLng : null,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          },
        )
        .then(async (response) => {
          let newStores: Array<StoresType> = [];

          if (!response.data || response.data.success === false) {
            setLoading(false);
            //Fazer um for para mostrar todos os produtos e mostrar na tela
            if (response.data.dataEmpty) {
              const ids = response.data.dataEmpty.map((prod: any) => prod.sku);
              const filtered = response.data.dataEmpty.filter(
                (prod: any, index: number) =>
                  !ids.includes(prod.sku, index + 1),
              );

              Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text:
                  response.data.dataEmpty && response.data.dataEmpty.length > 0
                    ? `Produtos: ${filtered
                        .map((u: any) => u.name)
                        .join(", ")} sem estoque`
                    : "Não foi possível encontrar formas de envio para o CEP.",
              });
              const newProducts = orderSave.products.map((produto) => {
                if (ids.includes(produto.sku)) produto.outStock = true;
                return produto;
              });
              setOrder({
                products: newProducts,
              });
            } else {
              const filtered: any = [];
              Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text:
                  response.data.dataEmpty && response.data.dataEmpty.length > 0
                    ? `Produtos: ${filtered
                        .map((u: any) => u.name)
                        .join(", ")} sem estoque`
                    : "Não foi possível encontrar formas de envio para o CEP.",
              });
            }

            setCanWithdraw(false);
            setStores([]);
            setFindCep(false);
            return;
          }
          //Fazer validação dos produtos desativados no retorno ;

          // comparar sku enviado com os retornados.
          // const ids = response.data.map((prod: any) => prod.sku);
          // const filtered = response.data.filter((prod: any, index: number) => !ids.includes(prod.sku, index + 1));
          // let doesNotexists = skus.map((skus: any) => {
          // 	const find = filtered.find((prod: any) => prod.sku === skus)

          // 	if (!find) {
          // 		return skus
          // 	}
          // })

          // doesNotexists = doesNotexists.filter((skus: any) => skus !== undefined);

          // if (doesNotexists.length > 0) {

          // 	const produtos = doesNotexists.map((skus: any) => {

          // 		const find = orderSave.products.find((prod: any) => prod.sku === skus)

          // 		return find!.name

          // 	})

          // 	setLoading(false)
          // 	Swal.fire({
          // 		icon: "warning",
          // 		title: 'Atenção!',
          // 		text: (response.data.dataEmpty && response.data.dataEmpty.length > 0) ?
          // 			`Produtos: ${filtered.map((u: any) => u.name).join(', ')} sem estoque`
          // 			: 'Não foi possível encontrar formas de envio para o CEP.'

          // 	});
          // 	let skusEmpty = response.data.dataEmpty.map((item: ItemEmptyType) => item.sku)
          // 	const newProducts: ProductType[] = orderSave.products.map(produto => {
          // 		if (skusEmpty.includes(produto.sku)) produto.outStock = true;
          // 		return produto
          // 	})

          // 	setOrder({
          // 		products: newProducts
          // 	})

          // 	setCanWithdraw(false);
          // 	setStores([]);
          // 	setFindCep(false);
          // 	return

          // }

          setProductStores(response.data);
          response.data.forEach((str: StoresType) => {
            const newStore = {
              id: str.id,
              name: str.name,
              city: str.city,
              district: str.district,
              street: str.street,
              number: str.number,
              distance: str.distance,
              currentBalance: str.currentBalance,
            };
            const findedStore = newStores.find(
              (findStore) =>
                findStore.name === newStore.name &&
                findStore.distance === newStore.distance,
            );
            if (!findedStore) {
              localStorage.setItem("storeAddress", JSON.stringify(newStore));
              newStores.push(newStore);
            }
          });
          setCanWithdraw(true);
          await findCepAdress(noMaskCep);
          cepSended
            ? await findCepDelivery(cepSended)
            : await findCepDelivery();

          setStores(newStores);
          if (typeFreight === "delivery" && valueCep) {
            setFreightFind(valueCep);
          }
          setLoading(false);

          orderContext.setOrderToVerify(orderSave);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
          Swal.fire({
            icon: "warning",
            title: "Erro!",
            text: "Falha ao buscar CEP",
          });
        });
    }

    if (isSeller) {
      await setDiscount();
    }
  }

  // função movida para a PluginSpaceContex  07/12/2023 - Bernnardo Pestana

  /*
	async function getLocations() {

		//Validação das localizações da loja para que busque do localStorage.
		//Caso exista não precisa buscar novamente, mais indicado para o FOOD

		//Essa função vai ser replicada para o ModalWithDrawl e ModalDelivery,
		//uma vez que fazem a pesquisa da location para recuperar alguns dados.


		const locationsInLocalStore = localStorage.getItem('locations');

		if (locationsInLocalStore) {

			const newLocation = JSON.parse(locationsInLocalStore)

			setLocations(
				newLocation
			);

		} else {
			await api
				.get(`/api/location`, {
					headers: {
						Authorization: `Bearer ${await getToken()}`,
					},
				})
				.then(async (response) => {
					const newLocations = response.data.data.map(
						(location: LocationType) => ({
							id: location.id,
							name: location.name,
							code: location.code,
							status: location.status,
							type: location.type,
							cep: location.cep,
							address: location.address
						})
					);
					const newLocationsFiltered = newLocations.filter(
						(loc: LocationType) => loc.status === true
					)
					setLocations(
						newLocationsFiltered
					);

					localStorage.setItem('locations', JSON.stringify(newLocationsFiltered));
				})
				.catch((err) => {
					console.log(err);
				});
		}

	}
*/

  const getLandmark = () => {
    const landmark = localStorage.getItem("landmark_synkar");
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark));
      return landmarkItem.interval;
    } else {
      return null;
    }
  };

  const getLandmarkPluginbot = () => {
    const landmark = localStorage.getItem("landmark_pluginbot");
    if (landmark) {
      const landmarkItem = JSON.parse(window.atob(landmark));
      return landmarkItem.interval;
    } else {
      return null;
    }
  };

  const getInternalDelivery = () => {
    const internalDelivery = localStorage.getItem("internal_number");
    return internalDelivery ? true : null;
  };

  const getCardNumber = () => {
    const cardNumber = localStorage.getItem("card_number");
    return cardNumber ? cardNumber : null;
  };

  const getCounterNumber = () => {
    const counterNumber = localStorage.getItem("counter_number");
    return counterNumber ? counterNumber : null;
  };

  const getTableNumber = () => {
    const tableNumber = localStorage.getItem("table_number");
    return tableNumber ? tableNumber : null;
  };

  async function openModalToSendOrderFood() {
    const isCartValid = await validateAndCleanCart();
    if (!isCartValid) {
      await refreshOrderFromContext();
      return;
    }

    setTypeModal("Enviar pedido");
    trackInitiateCheckout();
    setOpenModal(true);
  }

  // função mudada para o modal do Food
  const sendTableOrder = async () => {
    const isCartValid = await validateAndCleanCart();
    if (!isCartValid) {
      await refreshOrderFromContext();
      return;
    }

    setLoading(true);
    const orderData: OrderToSendType | undefined =
      await generateDataToSendOrderCard(
        {
          id: 0,
          name: "",
          cpf: "",
          telephone: "",
          acceptTermDate: new Date(),
        },
        "",
        uuidv4(),
        false,
      );
    const tableNumber = getTableNumber();
    if (orderData && tableNumber) {
      const result = await api
        .post(
          "/api/orders/send-food-order",
          { ...orderData, tableNumber: atob(tableNumber) },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          },
        )
        .then((response) => {
          return response.data;
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            return err.response.data;
          }
          return null;
        });
      setLoading(false);
      if (result && result.success === true) {
        setOrderId(result.dados.orderId);
        setOrderIdExt(result.dados.orderidExt);
        clearOrder();
        Swal.fire({
          icon: "success",
          title: "Pedido enviado com sucesso!",
        });
        navigate(`/${pluginspace_id}/products`, { replace: true });
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text:
            result && result.message
              ? result.message
              : "Não foi possível enviar o pedido",
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível enviar o pedido",
      });
    }
  };

  const continueSynkar = async () => {
    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      await Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue,
        )}`,
      });
      return;
    }
    setLoading(true);
    const locationSynkar = locations.find((loc) => loc.code === "synkar");
    const locationStore = locations.find((loc) => loc.type === "address");

    if (locationSynkar && locationStore) {
      await calculateDiscount();
      setLoading(false);
      setType("synkar");

      setOrderAddress({
        address: locationStore.address ? locationStore.address.street : "",
        cep: locationStore.cep,
        state: locationStore.address ? locationStore.address.state : "",
        city: locationStore.address ? locationStore.address.city : "",
        complement: locationStore.address ? locationStore.address.extra : "",
        district: locationStore.address ? locationStore.address.district : "",
        name: locationStore.name,
        number: locationStore.address ? locationStore.address.number : "",
        reference: "",
      });
      trackInitiateCheckout();
      setLocationId(locationSynkar.id);
      navigate(`/${pluginspace_id}/customer`);
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível encontrar a modalidade de automação",
      });
    }
  };

  const continuePluginbot = async () => {
    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      await Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue,
        )}`,
      });
      return;
    }
    setLoading(true);
    const locationPluginbot = locations.find((loc) => loc.code === "pluginbot");
    const locationStore = locations.find((loc) => loc.type === "address");

    if (locationPluginbot && locationStore) {
      await calculateDiscount();
      setLoading(false);
      setType("pluginbot");

      setOrderAddress({
        address: locationStore.address ? locationStore.address.street : "",
        cep: locationStore.cep,
        state: locationStore.address ? locationStore.address.state : "",
        city: locationStore.address ? locationStore.address.city : "",
        complement: locationStore.address ? locationStore.address.extra : "",
        district: locationStore.address ? locationStore.address.district : "",
        name: locationStore.name,
        number: locationStore.address ? locationStore.address.number : "",
        reference: "",
      });
      setLocationId(locationPluginbot.id);
      navigate(`/${pluginspace_id}/customer`);
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível encontrar a modalidade de automação",
      });
    }
  };

  const continueCounter = async () => {
    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      await Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue,
        )}`,
      });
      return;
    }

    if (typePluginspace === "food") {
      const isCartValid = await validateAndCleanCart();
      if (!isCartValid) {
        await refreshOrderFromContext();
        return;
      }
    }

    setLoading(true);
    const locationCounter = locations.find((loc) => loc.code === "counter");
    const locationStore = locations.find((loc) => loc.type === "address");

    if (locationCounter && locationStore) {
      await calculateDiscount();
      setLoading(false);
      setType("counter");

      setOrderAddress({
        address: locationStore.address ? locationStore.address.street : "",
        cep: locationStore.cep,
        state: locationStore.address ? locationStore.address.state : "",
        city: locationStore.address ? locationStore.address.city : "",
        complement: locationStore.address ? locationStore.address.extra : "",
        district: locationStore.address ? locationStore.address.district : "",
        name: locationStore.name,
        number: locationStore.address ? locationStore.address.number : "",
        reference: "",
      });
      trackInitiateCheckout();
      setLocationId(locationCounter.id);
      navigate(`/${pluginspace_id}/customer`);
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível encontrar a modalidade de automação",
      });
    }
  };

  const continueInternalDelivery = async () => {
    const purchaseMin = validatePurchaseMin();

    if (!purchaseMin) {
      await Swal.fire({
        icon: "warning",
        title: "Atenção",
        text: `A sua compra não atingiu o valor mínimo de ${floatToPrice(
          minimumValue,
        )}`,
      });
      return;
    }
    setLoading(true);
    const locationInternalDelivery = locations.find(
      (loc) => loc.code === "internal-delivery",
    );
    const locationStore = locations.find((loc) => loc.type === "address");
    const internalDeliveryNumber = localStorage.getItem("internal_number");
    const internalDeliveryName = localStorage.getItem("internal_name");
    if (locationInternalDelivery && locationStore && internalDeliveryNumber) {
      await calculateDiscount();
      setLoading(false);
      setType("internal-delivery");

      setOrderAddress({
        address: locationStore.address ? locationStore.address.street : "",
        cep: locationStore.cep,
        state: locationStore.address ? locationStore.address.state : "",
        city: locationStore.address ? locationStore.address.city : "",
        complement: internalDeliveryName
          ? `${window.atob(internalDeliveryName)} ${window.atob(
              internalDeliveryNumber,
            )}`
          : window.atob(internalDeliveryNumber),
        district: locationStore.address ? locationStore.address.district : "",
        name: `${locationStore.name}`,
        number: locationStore.address ? locationStore.address.number : "",
        reference: "",
      });
      setLocationId(locationInternalDelivery.id);
      trackInitiateCheckout();
      navigate(`/${pluginspace_id}/customer`);
    } else {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível encontrar a modalidade de entrega interna",
      });
    }
  };

  async function calculateDiscount() {
    if (totvsVarejoAble) {
      setLoading(true);
      const products = order?.products.map((product) => ({
        hash: window.btoa(product.code),
        id: product.id,
        productName: product.name,
        image: product.image,
        stock: product.stock,
        code: product.code,
        locationId: product.locationId,
        quantity: product.quantity,
        discount:
          product.promotionalPrice !== product.unitPrice &&
          product.promotionalPrice !== 0
            ? parseInt(
                ((product.unitPrice - product.promotionalPrice) * 100).toFixed(
                  0,
                ),
              )
            : 0,
        price:
          product.promotionalPrice !== product.unitPrice &&
          product.promotionalPrice !== 0
            ? parseInt(
                ((product.unitPrice - product.promotionalPrice) * 100).toFixed(
                  0,
                ),
              )
            : parseInt((product.unitPrice * 100).toFixed(0)),
        unitPrice: parseInt((product.unitPrice * 100).toFixed(0)),
        codFilial: pluginspaceData?.id,
        info: "",
        chair: "",
        notes: "",
        productSku: product.sku,
        variation: Object.entries(product.variation).map((obj) => ({
          grid: obj[0],
          value: obj[1],
        })),
      }));
      await api
        .post(
          "/api/totvsPromotionEngine/calculatePromotion",
          {
            "couponPromotionalCode--": coupon,
            discountGeneral: 0.0,
            products,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          },
        )
        .then(async (response) => {
          setLoading(false);
          if (response.data) {
            const newProducts: Array<ProductType> = response.data.products.map(
              (product: ProductTotvsType) => {
                let objVar: any = {};
                product.variation.forEach((variation) => {
                  objVar[variation.grid] = variation.value;
                });
                return {
                  id: product.id,
                  name: product.productName,
                  image: product.image,
                  unitPrice: parseFloat((product.unitPrice / 100).toFixed(2)),
                  promotionalPrice: product.price
                    ? parseFloat(
                        ((product.unitPrice - product.discount) / 100).toFixed(
                          2,
                        ),
                      )
                    : parseFloat(
                        ((product.unitPrice - product.discount) / 100).toFixed(
                          2,
                        ),
                      ),
                  quantity: product.quantity,
                  stock: product.stock,
                  sku: product.productSku,
                  variation: objVar,
                  code: product.code,
                  locationId: product.locationId,
                  pluginspaceHash: pluginspace_id,
                };
              },
            );
            await orderContext.changeOrderByGuidCart(newProducts, orderContext);
            orderContext.setDiscountGeneral(
              response.data.totalAmountDiscount
                ? response.data.totalAmountDiscount
                : 0,
            );
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          return null;
        });
    }
  }

  async function calculateNinegridDiscount() {
    if (
      ninegridMotorAble &&
      allowDiscountSeller &&
      ninegridMotorConfig &&
      (parseFloat(descontoPercent) > 0 || parseFloat(descontoMonetario) > 0)
    ) {
      //verificar os valores do desconto se são menores ou iguais aos limites impostos
      // Tipo Desconto = 0 money | 1 - percentage
      // token do Vendedor para validar seu limite de desconto

      if (total <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Desconto inválido!",
          text: "Desconto maior que o valor da venda.",
        }).then((result) => {
          setModalIsOpen(false);
        });
        setModalIsOpen(false);

        await zerarDiscount();
        await loadOrder();
        await orderContext.setDiscountGeneral(0);
        return false;
      }

      if (discountType == 0) {
        if (ninegridMotorConfig.maxMonetary < parseFloat(descontoMonetario)) {
          setLoading(false);
          setModalIsOpen(false);

          Swal.fire({
            icon: "warning",
            title: "Desconto inválido!",
            text: `Seu limite máximo de desconto é de ${floatToPrice(
              parseFloat(ninegridMotorConfig!.maxMonetary.toString()),
            )} para essa venda`,
          }).then(() => setModalIsOpen(false));

          await zerarDiscount();
          await loadOrder();
          await orderContext.setDiscountGeneral(0);
          return false;
        }
      } else {
        const limit = geralDiscount
          ? ninegridMotorConfig!.maxPercentage < parseFloat(descontoPercent)
          : maxDiscountSeller < parseFloat(descontoPercent);

        const value = geralDiscount
          ? ninegridMotorConfig!.maxPercentage
          : maxDiscountSeller;

        if (limit) {
          setLoading(false);
          setModalIsOpen(false);
          Swal.fire({
            icon: "warning",
            title: "Desconto inválido!",
            text: `Seu limite máximo de desconto é de ${floatToPercent(
              value,
            )} para essa venda`,
          }).then(() => setModalIsOpen(false));

          await zerarDiscount();
          await loadOrder();
          await orderContext.setDiscountGeneral(0);

          return false;
        }
      }

      setLoading(true);
      const tk = getTokenSeller();

      const newOrder = await orderContext.getOrder();

      const products = newOrder.products.map((product) => ({
        hash: window.btoa(product.code),
        id: product.id,
        productName: product.name,
        image: product.image,
        stock: product.stock,
        code: product.code,
        locationId: product.locationId,
        quantity: product.quantity,
        //discount: (product.promotionalPrice !== product.unitPrice && product.promotionalPrice !== 0) ? parseInt(((product.unitPrice - product.promotionalPrice) * 100).toFixed(0)) : 0,
        price:
          product.promotionalPrice !== product.unitPrice &&
          product.promotionalPrice !== 0
            ? parseInt((product.promotionalPrice * 100).toFixed(0))
            : parseInt((product.unitPrice * 100).toFixed(0)),
        unitPrice:
          product.promotionalPrice !== product.unitPrice &&
          product.promotionalPrice !== 0
            ? parseInt((product.promotionalPrice * 100).toFixed(0))
            : parseInt((product.unitPrice * 100).toFixed(0)),
        //unitPrice: parseInt((product.unitPrice * 100).toFixed(0)),
        codFilial: pluginspaceData?.id,
        discountValue: 0,
        discountPercentageValue: 0,
        info: "",
        chair: "",
        notes: "",
        productSku: product.sku,
        measures: product.measures,
        variation: Object.entries(product.variation).map((obj) => ({
          grid: obj[0],
          value: obj[1],
        })),
      }));

      const payload = {
        couponPromotionalCode: "",
        totalAmountDiscount: parseFloat(descontoMonetario),
        percentageDiscountTotalAmount: parseFloat(descontoPercent),
        discountGeneral: 0,
        products: products,
      };
      await api
        .post("/api/discount-enginer/calcdiscount", payload, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response) => {
          setLoading(false);
          if (response.data) {
            const data = response.data.data.data;
            const newProducts: Array<ProductType> = data.products.map(
              (product: any) => {
                let objVar: any = {};
                product.variation.forEach((variation: any) => {
                  objVar[variation.grid] = variation.value;
                });
                return {
                  id: product.id,
                  name: product.productName,
                  image: product.image,
                  unitPrice: parseFloat((product.unitPrice / 100).toFixed(2)),
                  promotionalPrice: product.price
                    ? parseFloat(
                        ((product.unitPrice - product.discount) / 100).toFixed(
                          2,
                        ),
                      )
                    : parseFloat(
                        ((product.unitPrice - product.discount) / 100).toFixed(
                          2,
                        ),
                      ),
                  quantity: product.quantity,
                  stock: product.stock,
                  sku: product.productSku,
                  measures: product.measures,
                  variation: objVar,
                  code: product.code,
                  locationId: product.locationId,
                  pluginspaceHash: pluginspace_id,
                };
              },
            );

            /*await orderContext.changeOrderByGuidCart(
							newProducts,
							orderContext
						);*/
            await orderContext.setOrderWithDiscount(newProducts);

            setOrder({
              products: newProducts,
            });

            await orderContext.setDiscountGeneral(
              data.totalAmountDiscount ? data.totalAmountDiscount : 0,
            );

            if (config?.content.pdv.sellerCheckout == 1) {
              setSellerModalIsOpen(true);
            } else {
              await chooseAddress();
            }
          }
        })
        .catch((err) => {
          setLoading(false);

          Swal.fire({
            icon: "warning",
            title: "Desconto não aplicado!",
            text: "Descontos não aplicados, deseja continuar mesmo assim",

            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: "Sim, continuar!",
            cancelButtonText: "Não, cancelar!",
          }).then(async (result) => {
            if (result.isConfirmed) {
              const newOrder = await orderContext.getOrder();
              await orderContext.setOrderWithDiscount(newOrder.products);
              if (config?.content.pdv.sellerCheckout == 1) {
                setSellerModalIsOpen(true);
              } else {
                await chooseAddress();
              }
            }
          });

          console.log(err);
          return null;
        });
      setLoading(false);
    } else {
      const newOrder = await orderContext.getOrder();
      await orderContext.setOrderWithDiscount(newOrder.products);

      if (config?.content.pdv.sellerCheckout == 1) {
        setSellerModalIsOpen(true);
      } else {
        await chooseAddress();
      }
    }
  }

  //Pesquisar o cep digitado e repassar para a função de salvar endereço do cliente no localStorage
  async function findCepAdress(cep2: string) {
    return await api
      .get(`https://viacep.com.br/ws/${cep2.replace("-", "")}/json/`)
      .then((response) => {
        if (response.data.erro) {
          Swal.fire({
            icon: "warning",
            title: "CEP inválido!",
            text: "Verifique se o CEP foi digitado corretamente.",
          });
          return false;
        } else {
          changeCustomerAdressByCartPage({
            address: response.data.bairro,
            cep: cep2.replace("-", ""),
            city: response.data.localidade,
            complement: response.data.cep,
            district: response.data.logradouro,
            name: "",
            number: "",
            reference: "",
            telephone: "",
            state: response.data.uf,
            ibge: response.data.ibge,
          });
          setCep(response.data.cep);

          return true;
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "warning",
          title: "CEP inválido!",
          text: "Verifique se o CEP foi digitado corretamente.",
        });
        return false;
      });
  }

  async function getVerifyShift() {
    try {
      const pgData = await getThisPluginspace();
      const response = await api.post(
        `api/location-operation/verify`,
        {},
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      );
      if (pgData && pgData.type === "food") {
        setValidShift(response.data && response.data.success);
      } else {
        setValidShift(true);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const createCart = async () => {
    if (orderContext.shouldUpdadeCart) {
      const link = `${window.location.origin}/${
        window.location.pathname.split("/")[1]
      }/cart`;

      if (!orderContext.guidCart) {
        //create
        const jsonCart = {
          products: order!.products,
          address: {},
          type: typeFreight,
          freight: freightFind,
          totalDiscount: 0,
        };

        const objCustomerCart = {
          customerName: "",
          cpfCustomer: "",
          phoneCustomer: "",
          cpfSeller: orderContext.cpfVendor,
          jsonCart: jsonCart,
          locationId: order!.products[0].locationId,
          urlcart: link + "?cart=",
        };
        await api
          .post(`/api/customerCart`, objCustomerCart, {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          })
          .then(async (response) => {
            console.log(response);

            if (response.status === 201) {
              const data = response.data.dados;
              orderContext.setGuidCart(data.guid);

              orderContext.setGuidCartNew(data.guid);
            } else {
              setLoading(false);
              Swal.fire({
                icon: "error",
                title: "Erro ao criar carrinho",
              });
            }
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Erro ao criar carrinho",
            });
            console.log(err);
            setLoading(false);
          });

        return;
      }
    }

    return;
  };

  const verifyStock = async () => {
    setLoading(true);
    const locationType = locations.find((loc) => typeFreight === loc.code);
    let success = true;
    if (locationType && !(config && config.content.pdv.showOutStock)) {
      const orderSave = await orderContext.getOrder();
      await api
        .post(
          `/api/variations/sku-inventory`,
          {
            skus:
              orderSave && orderSave.products
                ? orderSave.products.map((p) => p.sku)
                : [],
            locationId: locationType.id,
            status: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          },
        )
        .then(async (response) => {
          if (response.data && response.data.success && response.data.data) {
            const itemsSku = response.data.data.filter(
              (product: any) => product.inventory <= 0,
            );
            if (itemsSku.length > 0) {
              let skusEmpty = itemsSku.map((item: ItemEmptyType) => item.sku);
              const newProducts = orderSave.products.map((produto) => {
                if (skusEmpty.includes(produto.sku)) produto.outStock = true;
                return produto;
              });
              Swal.fire({
                icon: "warning",
                title: "Atenção!",
                text: `Produtos: ${itemsSku
                  .map((u: any) => u.name)
                  .join(", ")} sem estoque`,
              });
              setOrder({
                products: newProducts,
              });
              success = false;
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: `Falha ao recuperar estoque de produtos`,
            });
            success = false;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: `Falha ao recuperar estoque de produtos`,
          });
          success = false;
        });
    }
    setLoading(false);
    return success;
  };

  const getUserPosition = async () => {
    setLoading(true);
    await navigator.geolocation.getCurrentPosition(
      async (positionGet) => {
        setPosition({
          latitude: positionGet.coords.latitude,
          longitude: positionGet.coords.longitude,
        });
        setLoading(true);
        await api
          .post(
            `/api/maps/cep-by-geolocation`,
            {
              latitude: positionGet.coords.latitude,
              longitude: positionGet.coords.longitude,
            },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            },
          )
          .then(async (response) => {
            if (
              response.data &&
              response.data.success &&
              response.data.data &&
              response.data.data.length > 0
            ) {
              setCep(response.data.data[0].cep);
              setAddressMapLocation({
                cep: response.data.data[0].cep,
                city: response.data.data[0].city,
                street: response.data.data[0].street,
                district: response.data.data[0].district,
                streetNumber: response.data.data[0].streetNumber,
                state: response.data.data[0].state,
                latLng: {
                  latitude: positionGet.coords.latitude,
                  longitude: positionGet.coords.longitude,
                },
              });

              await getStores(response.data.data[0].cep, {
                latitude: positionGet.coords.latitude,
                longitude: positionGet.coords.longitude,
              });
              if (typeFreight === "delivery" && valueCep) {
                setFreightFind(valueCep);
              }
              setLoading(false);
            } else {
              Swal.fire({
                icon: "error",
                title: "Erro!",
                text: `Impossível recuperar localização do usuário`,
              });
            }
          })
          .catch((e) => {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: `Impossível recuperar localização do usuário`,
            });
          });
      },
      () => {
        Swal.fire({
          icon: "warning",
          title: "Atenção!",
          text: "É necessário ativar a localização para usá-la",
        });
      },
    );
  };

  useEffect(() => {
    zerarDiscount();
    loadOrder();
    orderContext.setDiscountGeneral(0);
  }, [totalWithoutDiscount.toString()]);

  return (
    <div className="cart">
      <div className="content-cart">
        {!loadingHeader && (
          <MiniHeader
            name="cart"
            title="Carrinho de compras"
            fontColor={
              config?.webappcolor.fontheader
                ? config.webappcolor.fontheader
                : "#636363"
            }
            backgroundColor={
              config?.webappcolor.backgroundheader
                ? config.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
          />
        )}
        {loading ? (
          <div
            style={{
              width: "100%",
              height: `calc(${loadingHeader ? "100vh" : "100vh - 7em"})`,
            }}
          >
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <div className="cart-body">
            <div className="cart-items">
              {order &&
                order.products.map((prod) => (
                  <CartItem
                    typePluginspace={typePluginspace}
                    product={prod}
                    key={prod.id}
                    showOutStock={config?.content.pdv.showOutStock}
                    motorTotvs={totvsMotorAble}
                    reloadProducts={async () => await loadOrder()}
                  />
                ))}
            </div>
            <div className="total-value-products">
              <p>Valor total dos produtos</p>
              <p className="price">{floatToPrice(totalWithoutDiscount)}</p>
            </div>
            {!isSeller &&
              !isTable &&
              !isCard &&
              !isLandmark &&
              !isPluginbot &&
              !isCounter &&
              !isInternalDelivery && (
                <div className="delivery-order">
                  <h2>Insira o CEP de sua localidade</h2>
                  <div className="freight">
                    <div className="freight-input">
                      <p
                        className="freight-text-input"
                        style={
                          cepAlarm ? { color: "#940C0C" } : { color: "#636363" }
                        }
                      >
                        CEP:{" "}
                      </p>
                      <InputMask
                        mask="99999-999"
                        className="freight-field"
                        type="text"
                        value={cep}
                        onFocus={() => setHideMenu(true)}
                        onBlur={() => {
                          setHideMenu(false);
                        }}
                        onChange={(value) => {
                          setCep(value.target.value);
                          setFindCep(false);
                          setCanWithdraw(false);
                          // if (!value.target.value.includes("_")) {
                          //   getStores(value.target.value);
                          // }
                        }}
                        placeholder="XXXXX-XXX"
                        onKeyDown={(event) => {
                          if (event.key === "Enter") getStores();
                        }}
                      />

                      <PiMagnifyingGlass
                        fill={"#636363"}
                        className="freight-icon"
                        onClick={() => getStores()}
                      />
                    </div>
                    {cepAlarm && (
                      <p className="freight-alarm">
                        Opção de frete indisponível para essa localização
                      </p>
                    )}
                  </div>
                  {config?.content.pdv.ableUserLocation && (
                    <div className="button-use-location">
                      <MainButton
                        style={{ height: "2em" }}
                        color={
                          config?.webappcolor.fontbutton
                            ? config.webappcolor.fontbutton
                            : "#636363"
                        }
                        backgroundColor={
                          totvsMotorAble
                            ? config?.webappcolor.webappbutton
                              ? config.webappcolor.webappbutton
                              : "#EAEAEA"
                            : config?.webappcolor.webappbutton
                              ? `${config.webappcolor.webappbutton}33`
                              : "#EAEAEA33"
                        }
                        text="Usar minha localização atual"
                        icon={
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 281.16 411.13"
                            fill={
                              config?.webappcolor.fontbutton
                                ? config.webappcolor.fontbutton
                                : "#636363"
                            }
                          >
                            <g>
                              <g>
                                <path
                                  className="cls-1"
                                  d="M270.99,126.73c.42,23.17-6.36,44.56-16.23,65.18-15.06,31.45-35.33,59.44-58.01,85.64-15.11,17.45-31.35,33.93-47.27,50.67-5.64,5.93-11.69,5.96-17.49.29-35.28-34.52-67.87-71.28-93.36-113.83-12.19-20.35-22.6-41.58-26.58-65.22-5.99-35.68,2.26-68.39,24.1-96.87C66.99,12.36,108.57-5.55,158.69,1.5c49.9,7.02,84.46,35.71,103.68,82.39,5.62,13.64,8.13,28.06,8.62,42.84ZM184.46,130.71c-.05-24.61-19.54-44.16-43.95-44.08-24.7.07-43.94,19.69-43.84,44.7.09,23.58,20.12,43.27,43.96,43.19,24.2-.08,43.89-19.75,43.84-43.81Z"
                                />
                                <path
                                  className="cls-1"
                                  d="M86.65,313.7c-5.29,3.8-10.38,6.75-14.61,10.62-8.92,8.16-8.8,18.7-.02,27,8.46,7.99,18.9,12.27,29.99,14.97,30.28,7.37,60.3,6.98,89.67-4.24,5.49-2.1,10.77-5.34,15.41-9.01,11.5-9.09,11.56-20.93.36-30.33-3.89-3.27-8.42-5.76-13.02-8.84,6.14-6.99,12.19-13.99,18.44-20.81.74-.81,2.75-1.13,3.9-.77,16.59,5.12,32.67,11.39,46.31,22.53,24.42,19.94,24.07,44.28-.83,63.8-16.74,13.12-36.24,20.13-56.61,24.82-49.78,11.47-99.23,10.41-148.07-5.11-15.79-5.01-30.6-12.1-43.02-23.44-6.26-5.71-11.28-12.29-13.44-20.6-3.53-13.55,1.79-24.43,10.94-33.91,11.87-12.31,27.03-19.1,42.66-24.97,11.77-4.42,11.8-4.31,20.07,5.01,3.95,4.45,7.93,8.88,11.88,13.29Z"
                                />
                              </g>
                            </g>
                          </svg>
                        }
                        onClick={async () => await getUserPosition()}
                      />
                    </div>
                  )}
                  {findCep &&
                    locations.find((loc) => loc.code === "delivery") && (
                      <div className="options-freight">
                        <div className="button-freight">
                          <div
                            className="delivery-type"
                            onClick={() => {
                              setTypeFreight("delivery");
                              setFreightFind(valueCep);
                            }}
                          >
                            {typeFreight === "delivery" && (
                              <div className="checked-delivery-type" />
                            )}
                          </div>
                        </div>
                        <div className="options">
                          <div className="option">
                            <div>
                              <svg
                                width="26"
                                height="25"
                                viewBox="0 0 26 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M24.5829 16.4621C25.8063 16.714 26.3101 17.7219 25.8063 18.9818C25.7344 19.2337 25.3745 19.4017 25.0867 19.4857C24.511 19.5697 23.9352 19.4857 23.3595 19.4857C22.5679 22.6773 21.2725 24.1052 19.2575 24.0212C17.3144 23.9372 15.947 22.3414 15.4433 19.5697C13.7881 19.5697 12.0609 19.5697 10.3337 19.5697C10.1898 21.1655 9.68602 22.5093 8.53457 23.3492C6.1597 25.113 2.99321 23.5172 2.70535 20.2416C2.48945 18.0579 2.63338 15.8741 2.63338 13.6064C4.50449 13.6064 6.44757 13.6064 8.31867 13.6064C8.96636 13.6064 9.18226 13.3544 9.03833 12.5985C8.96636 11.9266 8.53457 12.0946 8.17474 12.0946C5.72791 12.0946 3.28108 12.0946 0.834243 12.0946C0.54638 12.0946 0.114586 11.8426 0.0426203 11.5906C-0.101311 11.0027 0.114586 10.6667 0.762277 10.6667C3.71287 10.6667 6.5915 10.6667 9.54209 10.6667C9.82995 10.6667 10.2617 10.4148 10.3337 10.1628C10.6216 9.49088 10.2617 9.15492 9.54209 9.15492C7.02329 9.15492 4.57646 9.15492 2.05766 9.15492C1.69783 9.15492 1.26604 9.23891 1.26604 8.56699C1.26604 7.89507 1.48193 7.72709 2.05766 7.72709C5.00825 7.47512 7.95885 7.47512 10.9094 7.47512C11.4852 7.47512 11.773 7.30714 11.7011 6.63522C11.7011 5.9633 11.2693 5.9633 10.8375 5.9633C8.96636 5.9633 7.16722 5.9633 5.29611 5.9633C3.78484 5.9633 2.27356 5.9633 0.762277 5.9633C0.402449 5.87931 0.0426203 5.87931 0.0426203 5.20739C0.0426203 4.53546 0.402449 4.53546 0.834243 4.53546C1.40997 4.53546 1.91373 4.53546 2.63338 4.53546C2.63338 3.77955 2.63338 3.19162 2.63338 2.5197C2.63338 0.923891 3.42501 0 4.79236 0C8.10278 0 11.4132 0 14.6517 0C16.019 0 16.8106 0.923891 16.8106 2.5197C16.8106 3.19162 16.8106 3.77955 16.8106 4.53546C17.3144 4.53546 17.8181 4.53546 18.2499 4.53546C19.0416 4.45147 19.6173 4.78743 20.121 5.45936C21.3445 6.88719 22.5679 8.31502 23.7193 9.65886C24.2231 10.2468 24.511 10.9187 24.439 11.7586C24.511 13.2704 24.5829 14.8662 24.5829 16.4621ZM16.8826 11.9266C18.8257 11.9266 20.7687 11.9266 22.8557 11.9266C22.6398 11.5066 22.5679 11.1707 22.352 11.0027C21.4164 9.82684 20.3369 8.81896 19.4734 7.55911C18.7537 6.55123 17.8901 6.55123 16.8826 6.71921C16.8826 8.483 16.8826 10.1628 16.8826 11.9266ZM21.3445 19.5697C21.3445 18.3098 20.5528 17.302 19.4734 17.302C18.3939 17.302 17.4583 18.2258 17.4583 19.5697C17.4583 20.8295 18.3219 21.8374 19.4014 21.8374C20.4809 21.7534 21.3445 20.8295 21.3445 19.5697ZM8.4626 19.5697C8.4626 18.3098 7.67098 17.302 6.5915 17.302C5.51201 17.218 4.57646 18.2258 4.57646 19.4857C4.57646 20.7455 5.36808 21.7534 6.51953 21.7534C7.59902 21.7534 8.39064 20.8295 8.4626 19.5697Z"
                                  fill="#636363"
                                />
                              </svg>
                              <p>
                                {
                                  locations.find(
                                    (loc) => loc.code === "delivery",
                                  )?.name
                                }
                              </p>
                            </div>
                          </div>
                          <div className="option">
                            {/* <p>Receba em até 3 dias úteis</p> */}
                            <p></p>
                            <p className="value-freight">
                              +
                              {valueCep && valueCep !== 0
                                ? floatToPrice(valueCep)
                                : floatToPrice(0)}
                            </p>
                          </div>
                          <div className="option">
                            <p className="total">Total:</p>
                            <p className="value-total">
                              {floatToPrice(total + valueCep)}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  {canWithdraw &&
                    locations.find((loc) => loc.code === "withdraw") && (
                      <div
                        className="options-freight"
                        style={{ borderBottom: 0 }}
                      >
                        <div className="button-freight">
                          <div
                            className="delivery-type"
                            onClick={() => {
                              setTypeFreight("withdraw");
                              setFreightFind(valueWithDraw);
                            }}
                          >
                            {typeFreight === "withdraw" && (
                              <div className="checked-delivery-type" />
                            )}
                          </div>
                        </div>
                        <div className="options">
                          <div className="option">
                            <div>
                              <svg
                                width="23"
                                height="19"
                                viewBox="0 0 23 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.9695 6.80139C8.90547 6.80139 5.78013 6.80139 2.71606 6.80139C2.53222 6.80139 2.34837 6.80139 2.16453 6.80139C1.18403 6.67596 0.693776 5.86063 1.18403 5.0453C2.16453 3.54007 3.14503 1.97213 4.12553 0.529617C4.37066 0.278746 4.79963 0.0278746 5.10603 0.0278746C9.70213 0.0278746 14.2982 -0.0348432 18.8331 0.0278746C19.2007 0.0278746 19.6297 0.341463 19.8748 0.655052C20.8553 2.03484 21.7133 3.41463 22.6325 4.79443C22.9389 5.23345 23.184 5.73519 22.8163 6.17422C22.5099 6.4878 22.0197 6.73868 21.5907 6.73868C18.4041 6.80139 15.1562 6.80139 11.9695 6.80139Z"
                                  fill="#636363"
                                />
                                <path
                                  d="M12.0308 7.99304C12.7662 7.99304 13.4403 7.99304 14.1144 7.99304C14.1144 8.1812 14.1757 8.43207 14.1757 8.62022C14.1757 11.2544 14.1757 13.8885 14.1757 16.5227C14.1757 17.7143 13.8693 18.0906 12.6436 18.0906C10.0085 18.0906 7.43471 18.0906 4.79961 18.0906C3.57399 18.0906 3.2063 17.7143 3.2063 16.4599C3.2063 13.6376 3.2063 10.8781 3.2063 7.99304C3.94167 7.99304 4.61577 7.99304 5.35115 7.99304C5.35115 9.87457 5.35115 11.6934 5.35115 13.5749C7.55727 13.5749 9.7634 13.5749 11.9695 13.5749C12.0308 11.6934 12.0308 9.81186 12.0308 7.99304Z"
                                  fill="#636363"
                                />
                                <path
                                  d="M18.7105 7.93033C19.3846 7.93033 20.0587 7.93033 20.7941 7.93033C20.7941 8.11848 20.8554 8.30663 20.8554 8.49479C20.8554 11.3171 20.8554 14.1394 20.8554 16.9617C20.8554 17.2753 20.6715 17.8397 20.4877 17.8397C19.9974 17.9025 19.3846 17.8397 18.8944 17.777C18.8331 17.777 18.7105 17.4634 18.7105 17.2753C18.7105 14.2021 18.7105 11.1289 18.7105 8.05576C18.6492 8.05576 18.6492 8.05576 18.7105 7.93033Z"
                                  fill="#636363"
                                />
                              </svg>
                              <p>
                                {
                                  locations.find(
                                    (loc) => loc.code === "withdraw",
                                  )?.name
                                }
                              </p>
                            </div>
                          </div>
                          <div className="option">
                            {/* <p>Retire na loja a partir de 7 dias úteis</p> */}
                            <p></p>
                            <p className="value-freight">
                              {floatToPrice(valueWithDraw)}
                            </p>
                          </div>
                          <div className="option">
                            <p className="total">Total:</p>
                            <p className="value-total">
                              {floatToPrice(total + valueWithDraw)}
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              )}
            {isSeller && config?.content.pdv.sellerCheckout === 2 && (
              <div className="delivery-order">
                <h2>Insira o CEP do Comprador</h2>
                <div className="freight">
                  <div className="freight-input">
                    <p
                      className="freight-text-input"
                      style={
                        cepAlarm ? { color: "#940C0C" } : { color: "#636363" }
                      }
                    >
                      CEP:{" "}
                    </p>
                    <InputMask
                      mask="99999-999"
                      className="freight-field"
                      type="text"
                      value={cep}
                      onFocus={() => setHideMenu(true)}
                      onBlur={() => {
                        setHideMenu(false);
                      }}
                      onChange={(value) => {
                        setCep(value.target.value);
                        setFindCep(false);
                        setCanWithdraw(false);
                        if (!value.target.value.includes("_")) {
                          getStores(value.target.value);
                        }
                      }}
                      placeholder="XXXXX-XXX"
                      onKeyDown={(event) => {
                        if (event.key === "Enter") getStores();
                      }}
                    />
                    <i
                      className="fa fa-search freight-icon"
                      onClick={() => getStores()}
                    ></i>
                  </div>
                  {cepAlarm && (
                    <p className="freight-alarm">
                      Opção de frete indisponível para essa localização
                    </p>
                  )}
                </div>
                {findCep &&
                  locations.find((loc) => loc.code === "delivery") && (
                    <div className="options-freight">
                      <div className="button-freight">
                        <div
                          className="delivery-type"
                          onClick={() => {
                            setTypeFreight("delivery");
                            setFreightFind(valueCep);
                          }}
                        >
                          {typeFreight === "delivery" && (
                            <div className="checked-delivery-type" />
                          )}
                        </div>
                      </div>
                      <div className="options">
                        <div
                          className="option"
                          style={{
                            display: "flex",
                            justifyContent: "between",
                            marginBottom: "10px",
                          }}
                        >
                          <div>
                            <svg
                              width="26"
                              height="25"
                              viewBox="0 0 26 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M24.5829 16.4621C25.8063 16.714 26.3101 17.7219 25.8063 18.9818C25.7344 19.2337 25.3745 19.4017 25.0867 19.4857C24.511 19.5697 23.9352 19.4857 23.3595 19.4857C22.5679 22.6773 21.2725 24.1052 19.2575 24.0212C17.3144 23.9372 15.947 22.3414 15.4433 19.5697C13.7881 19.5697 12.0609 19.5697 10.3337 19.5697C10.1898 21.1655 9.68602 22.5093 8.53457 23.3492C6.1597 25.113 2.99321 23.5172 2.70535 20.2416C2.48945 18.0579 2.63338 15.8741 2.63338 13.6064C4.50449 13.6064 6.44757 13.6064 8.31867 13.6064C8.96636 13.6064 9.18226 13.3544 9.03833 12.5985C8.96636 11.9266 8.53457 12.0946 8.17474 12.0946C5.72791 12.0946 3.28108 12.0946 0.834243 12.0946C0.54638 12.0946 0.114586 11.8426 0.0426203 11.5906C-0.101311 11.0027 0.114586 10.6667 0.762277 10.6667C3.71287 10.6667 6.5915 10.6667 9.54209 10.6667C9.82995 10.6667 10.2617 10.4148 10.3337 10.1628C10.6216 9.49088 10.2617 9.15492 9.54209 9.15492C7.02329 9.15492 4.57646 9.15492 2.05766 9.15492C1.69783 9.15492 1.26604 9.23891 1.26604 8.56699C1.26604 7.89507 1.48193 7.72709 2.05766 7.72709C5.00825 7.47512 7.95885 7.47512 10.9094 7.47512C11.4852 7.47512 11.773 7.30714 11.7011 6.63522C11.7011 5.9633 11.2693 5.9633 10.8375 5.9633C8.96636 5.9633 7.16722 5.9633 5.29611 5.9633C3.78484 5.9633 2.27356 5.9633 0.762277 5.9633C0.402449 5.87931 0.0426203 5.87931 0.0426203 5.20739C0.0426203 4.53546 0.402449 4.53546 0.834243 4.53546C1.40997 4.53546 1.91373 4.53546 2.63338 4.53546C2.63338 3.77955 2.63338 3.19162 2.63338 2.5197C2.63338 0.923891 3.42501 0 4.79236 0C8.10278 0 11.4132 0 14.6517 0C16.019 0 16.8106 0.923891 16.8106 2.5197C16.8106 3.19162 16.8106 3.77955 16.8106 4.53546C17.3144 4.53546 17.8181 4.53546 18.2499 4.53546C19.0416 4.45147 19.6173 4.78743 20.121 5.45936C21.3445 6.88719 22.5679 8.31502 23.7193 9.65886C24.2231 10.2468 24.511 10.9187 24.439 11.7586C24.511 13.2704 24.5829 14.8662 24.5829 16.4621ZM16.8826 11.9266C18.8257 11.9266 20.7687 11.9266 22.8557 11.9266C22.6398 11.5066 22.5679 11.1707 22.352 11.0027C21.4164 9.82684 20.3369 8.81896 19.4734 7.55911C18.7537 6.55123 17.8901 6.55123 16.8826 6.71921C16.8826 8.483 16.8826 10.1628 16.8826 11.9266ZM21.3445 19.5697C21.3445 18.3098 20.5528 17.302 19.4734 17.302C18.3939 17.302 17.4583 18.2258 17.4583 19.5697C17.4583 20.8295 18.3219 21.8374 19.4014 21.8374C20.4809 21.7534 21.3445 20.8295 21.3445 19.5697ZM8.4626 19.5697C8.4626 18.3098 7.67098 17.302 6.5915 17.302C5.51201 17.218 4.57646 18.2258 4.57646 19.4857C4.57646 20.7455 5.36808 21.7534 6.51953 21.7534C7.59902 21.7534 8.39064 20.8295 8.4626 19.5697Z"
                                fill="#636363"
                              />
                            </svg>
                            <p>
                              {
                                locations.find((loc) => loc.code === "delivery")
                                  ?.name
                              }
                            </p>
                          </div>
                          <div
                            onClick={() => {
                              setModalEditFreight(true);
                              setTypeFreight("delivery");
                              setFreightFind(valueCep);
                            }}
                          >
                            <svg
                              fill="#636363"
                              height="20px"
                              width="20px"
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 31.982 31.982"
                            >
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                strokeLinejoin="round"
                              ></g>
                              <g id="SVGRepo_iconCarrier">
                                {" "}
                                <g>
                                  {" "}
                                  <path d="M3.952,23.15L0,31.955l8.767-3.992l0.018,0.019L3.938,23.13L3.952,23.15z M4.602,22.463L24.634,2.432l4.849,4.848 L9.45,27.312L4.602,22.463z M30.883,0.941c-2.104-1.963-4.488-0.156-4.488-0.156l4.851,4.843 C31.244,5.627,33.124,3.375,30.883,0.941z"></path>{" "}
                                </g>{" "}
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div className="option">
                          {/* <p>Receba em até 3 dias úteis</p> 
													<input
															type="text"
															className="inputSellerFrete"
															value={valueCep.toFixed(2) || ""}
															onChange={(value: any) => {
																const frete = parseFloat(value.target.value)
																setValueCep(frete)
															}}
														/>
													
													*/}
                          <p></p>
                          <p className="value-freight inputMoney">
                            +
                            {valueCep && valueCep !== 0
                              ? floatToPrice(valueCep)
                              : floatToPrice(0)}
                          </p>
                        </div>
                        <div className="option">
                          <p className="total">Total:</p>
                          <p className="value-total">
                            {floatToPrice(total + valueCep)}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                {canWithdraw &&
                  locations.find((loc) => loc.code === "withdraw") && (
                    <div
                      className="options-freight"
                      style={{ borderBottom: 0 }}
                    >
                      <div className="button-freight">
                        <div
                          className="delivery-type"
                          onClick={() => {
                            setTypeFreight("withdraw");
                            setFreightFind(valueWithDraw);
                          }}
                        >
                          {typeFreight === "withdraw" && (
                            <div className="checked-delivery-type" />
                          )}
                        </div>
                      </div>
                      <div className="options">
                        <div
                          className="option"
                          style={{
                            display: "flex",
                            justifyContent: "between",
                            marginBottom: "10px",
                          }}
                        >
                          <div>
                            <svg
                              width="23"
                              height="19"
                              viewBox="0 0 23 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.9695 6.80139C8.90547 6.80139 5.78013 6.80139 2.71606 6.80139C2.53222 6.80139 2.34837 6.80139 2.16453 6.80139C1.18403 6.67596 0.693776 5.86063 1.18403 5.0453C2.16453 3.54007 3.14503 1.97213 4.12553 0.529617C4.37066 0.278746 4.79963 0.0278746 5.10603 0.0278746C9.70213 0.0278746 14.2982 -0.0348432 18.8331 0.0278746C19.2007 0.0278746 19.6297 0.341463 19.8748 0.655052C20.8553 2.03484 21.7133 3.41463 22.6325 4.79443C22.9389 5.23345 23.184 5.73519 22.8163 6.17422C22.5099 6.4878 22.0197 6.73868 21.5907 6.73868C18.4041 6.80139 15.1562 6.80139 11.9695 6.80139Z"
                                fill="#636363"
                              />
                              <path
                                d="M12.0308 7.99304C12.7662 7.99304 13.4403 7.99304 14.1144 7.99304C14.1144 8.1812 14.1757 8.43207 14.1757 8.62022C14.1757 11.2544 14.1757 13.8885 14.1757 16.5227C14.1757 17.7143 13.8693 18.0906 12.6436 18.0906C10.0085 18.0906 7.43471 18.0906 4.79961 18.0906C3.57399 18.0906 3.2063 17.7143 3.2063 16.4599C3.2063 13.6376 3.2063 10.8781 3.2063 7.99304C3.94167 7.99304 4.61577 7.99304 5.35115 7.99304C5.35115 9.87457 5.35115 11.6934 5.35115 13.5749C7.55727 13.5749 9.7634 13.5749 11.9695 13.5749C12.0308 11.6934 12.0308 9.81186 12.0308 7.99304Z"
                                fill="#636363"
                              />
                              <path
                                d="M18.7105 7.93033C19.3846 7.93033 20.0587 7.93033 20.7941 7.93033C20.7941 8.11848 20.8554 8.30663 20.8554 8.49479C20.8554 11.3171 20.8554 14.1394 20.8554 16.9617C20.8554 17.2753 20.6715 17.8397 20.4877 17.8397C19.9974 17.9025 19.3846 17.8397 18.8944 17.777C18.8331 17.777 18.7105 17.4634 18.7105 17.2753C18.7105 14.2021 18.7105 11.1289 18.7105 8.05576C18.6492 8.05576 18.6492 8.05576 18.7105 7.93033Z"
                                fill="#636363"
                              />
                            </svg>
                            <p>
                              {
                                locations.find((loc) => loc.code === "withdraw")
                                  ?.name
                              }
                            </p>
                          </div>

                          <div
                            onClick={() => {
                              setModalEditFreight(true);
                              setTypeFreight("withdraw");
                              setFreightFind(valueWithDraw);
                            }}
                          >
                            <svg
                              fill="#636363"
                              height="20px"
                              width="20px"
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 31.982 31.982"
                            >
                              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                              <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                strokeLinejoin="round"
                              ></g>
                              <g id="SVGRepo_iconCarrier">
                                {" "}
                                <g>
                                  {" "}
                                  <path d="M3.952,23.15L0,31.955l8.767-3.992l0.018,0.019L3.938,23.13L3.952,23.15z M4.602,22.463L24.634,2.432l4.849,4.848 L9.45,27.312L4.602,22.463z M30.883,0.941c-2.104-1.963-4.488-0.156-4.488-0.156l4.851,4.843 C31.244,5.627,33.124,3.375,30.883,0.941z"></path>{" "}
                                </g>{" "}
                              </g>
                            </svg>
                          </div>
                        </div>

                        <div className="option">
                          {/* <p>Retire na loja a partir de 7 dias úteis</p> */}
                          <p>Valor da Retirada</p>
                          <p className="value-freight inputMoney">
                            +
                            <p className="value-freight">
                              {floatToPrice(valueWithDraw)}
                            </p>
                          </p>
                        </div>
                        <div className="option">
                          <p className="total">Total:</p>
                          <p className="value-total">
                            {floatToPrice(total + valueWithDraw)}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
              </div>
            )}
            {isSeller && ninegridMotorAble && allowDiscountSeller && (
              <>
                <div className="totalDiscountDiv">
                  <div className="Discount">
                    <div className="infoDiscount">
                      <div className="optionsDiscount">
                        <div className="optionDiscount">
                          <div className="optionDiscount2">
                            <input
                              type="radio"
                              name="whatsapp"
                              checked={discountType === 0}
                              onChange={async () => {
                                await zerarDiscount();
                                setOrder(orderSellerAux);
                                setDiscountType(0);
                              }}
                            />

                            <label>Desconto Monetário</label>
                          </div>
                          <div className="descMaxInfo">
                            <p>
                              Limite máx. {floatToPrice(monetaryDiscountMax)}
                            </p>
                          </div>
                        </div>
                        <div className="optionDiscount">
                          <div className="optionDiscount2">
                            <input
                              type="radio"
                              name="whatsapp"
                              checked={discountType === 1}
                              onChange={async () => {
                                await zerarDiscount();
                                setOrder(orderSellerAux);
                                setDiscountType(1);
                              }}
                            />
                            <label>Desconto em Porcentagem</label>
                          </div>

                          <div className="descMaxInfo">
                            <p>
                              Limite máx.{" "}
                              {geralDiscount
                                ? floatToPercent(percentyDiscountMax)
                                : floatToPercent(maxDiscountSeller)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {discountType == 0 ? (
                    /*
										1- Aqui usa valor monetário
										2- Tem a definição máxima configurada no plugin
										*/
                    <div className="total-value-products">
                      <p>Inserir desconto</p>
                      <Input
                        inputAttr={{
                          type: "money_Discount",
                        }}
                        label={""}
                        textCenter={true}
                        placeholder="Desconto"
                        value={descontoMonetario}
                        locale="pt-BR"
                        currency="BRL"
                        change={(value: string) => setDescontoMonetario(value)}
                        blur={() => setDiscount()}
                      />
                    </div>
                  ) : (
                    /*
										1- Aqui usa porcentagem
										2- Tem a definição máxima configurada no plugin
										3- tem a definição maxima configurada para o vendedor
										*/

                    <div className="total-value-products">
                      <p>Inserir desconto</p>
                      <Input
                        inputAttr={{
                          type: "percent",
                        }}
                        label={""}
                        textCenter={true}
                        placeholder=""
                        value={descontoPercent}
                        change={(value: string) => setDescontoPercent(value)}
                        blur={() => setDiscount()}
                      />
                    </div>
                  )}
                </div>
              </>
            )}

            {totvsVarejoAble && (
              <div className="coupon-discount">
                <input
                  type="text"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                  placeholder="Adicionar um cupom de desconto"
                />
                <i
                  className="fas fa-ticket-alt"
                  style={{ color: "#4B4D50" }}
                ></i>
              </div>
            )}

            <div style={{ padding: "0px 16px" }}>
              <FoodCashbackSection enabled={!totvsVarejoAble} />
            </div>
            <div
              className="resume-order"
              style={{
                color: config?.webappcolor.fontinfocart
                  ? config.webappcolor.fontinfocart
                  : "#636363",
              }}
            >
              <h1>Resumo do Pedido</h1>
              <div className="item-resume">
                <p>Subtotal</p>
                <p>{floatToPrice(totalWithoutDiscount)}</p>
              </div>
              <div className="item-resume">
                <p>Desconto</p>
                <p>-{floatToPrice(totalWithoutDiscount - total)}</p>
              </div>
              {!isCard && !isTable && !isCounter && (
                <div className="item-resume">
                  <p>
                    Taxa de{" "}
                    {typeFreight === "withdraw" ? "retirada" : "entrega"}
                  </p>
                  <p>+{floatToPrice(freightFind)}</p>
                </div>
              )}
              <div className="item-total-resume">
                <p>TOTAL</p>
                <p>{floatToPrice(total + freightFind)}</p>
              </div>
            </div>
            {totvsVarejoAble && totvsMotorAble && (
              <div className="button-send-order">
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    totvsMotorAble
                      ? config?.webappcolor.webappbutton
                        ? config.webappcolor.webappbutton
                        : "#EAEAEA"
                      : config?.webappcolor.webappbutton
                        ? `${config.webappcolor.webappbutton}33`
                        : "#EAEAEA33"
                  }
                  text="Calcular desconto"
                  onClick={async () => await calculateDiscount()}
                />
              </div>
            )}

            <div className="button-send-order">
              {isSeller ? (
                <>
                  {config?.content.pdv.sellerCheckout === 1 ? (
                    <MainButton
                      color={
                        config?.webappcolor.fontbutton
                          ? config.webappcolor.fontbutton
                          : "#636363"
                      }
                      backgroundColor={
                        config?.webappcolor.webappbutton
                          ? config.webappcolor.webappbutton
                          : "#EAEAEA"
                      }
                      text="Gravar carrinho"
                      onClick={async () => {
                        await calculateNinegridDiscount();
                      }}
                    />
                  ) : (
                    <>
                      {canWithdraw && (
                        <MainButton
                          color={
                            config?.webappcolor.fontbutton
                              ? config.webappcolor.fontbutton
                              : "#636363"
                          }
                          backgroundColor={
                            config?.webappcolor.webappbutton
                              ? config.webappcolor.webappbutton
                              : "#EAEAEA"
                          }
                          text="Continuar"
                          onClick={async () => {
                            {
                              localStorage.removeItem("qrcodePixPayment");
                              trackInitiateCheckout();
                              await calculateNinegridDiscount();
                            }
                          }}
                        />
                      )}
                    </>
                  )}
                </>
              ) : isTable ? (
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Enviar pedido"
                  onClick={() => openModalToSendOrderFood()}
                />
              ) : isCard ? (
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Enviar pedido"
                  onClick={async () => {
                    const isCartValid = await validateAndCleanCart();
                    if (!isCartValid) {
                      await refreshOrderFromContext();
                      return;
                    }

                    setTypeModal("Enviar pedido");
                    trackInitiateCheckout();
                    setOpenModal(true);
                  }}
                />
              ) : isLandmark ? (
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Continuar para o pagamento"
                  onClick={() => {
                    localStorage.removeItem("qrcodePixPayment");
                    continueSynkar();
                  }}
                />
              ) : isPluginbot ? (
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Continuar para o pagamento"
                  onClick={() => {
                    localStorage.removeItem("qrcodePixPayment");
                    continuePluginbot();
                  }}
                />
              ) : isCounter ? (
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Continuar para o pagamento"
                  onClick={() => {
                    localStorage.removeItem("qrcodePixPayment");
                    continueCounter();
                  }}
                />
              ) : isInternalDelivery ? (
                <MainButton
                  color={
                    config?.webappcolor.fontbutton
                      ? config.webappcolor.fontbutton
                      : "#636363"
                  }
                  backgroundColor={
                    config?.webappcolor.webappbutton
                      ? config.webappcolor.webappbutton
                      : "#EAEAEA"
                  }
                  text="Continuar para o pagamento"
                  onClick={() => {
                    localStorage.removeItem("qrcodePixPayment");
                    continueInternalDelivery();
                  }}
                />
              ) : (
                canWithdraw && (
                  <MainButton
                    color={
                      config?.webappcolor.fontbutton
                        ? config.webappcolor.fontbutton
                        : "#636363"
                    }
                    backgroundColor={
                      config?.webappcolor.webappbutton
                        ? config.webappcolor.webappbutton
                        : "#EAEAEA"
                    }
                    text="Ir para o pagamento"
                    onClick={async () => {
                      if (validShift) {
                        const successStock = await verifyStock();
                        if (successStock) {
                          localStorage.removeItem("qrcodePixPayment");
                          await createCart();
                          trackInitiateCheckout();
                          await calculateDiscount();
                          await chooseAddress();
                        }
                      } else {
                        Swal.fire({
                          icon: "warning",
                          title: "Atenção!",
                          text: `A loja se encontra fechada e não está aceitando pedidos`,
                        });
                      }
                    }}
                  />
                )
              )}
            </div>
          </div>
        )}
        {!loadingHeader && (
          <Menu
            activeMenu="cart"
            fontColor={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            activeFontColor={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#000"
            }
            backgroundMenu={
              config?.webappcolor.backgroundfooter
                ? config?.webappcolor.backgroundfooter
                : "#F5F5F5"
            }
            colorIcons={
              config?.webappcolor.iconsfooter
                ? config?.webappcolor.iconsfooter
                : "#636363"
            }
            highlightColorIcons={
              config?.webappcolor.highlightfooter
                ? config?.webappcolor.highlightfooter
                : "#636363"
            }
            hide={hideMenu || sellerModalIsOpen || modalIsOpen}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {sellerModalIsOpen && (
          <ModalSellerSave
            isOpen={sellerModalIsOpen}
            setIsOpen={setSellerModalIsOpen}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
          />
        )}
        {modalIsOpen && typeFreight === "delivery" && (
          <ModalDelivery
            isOpen={modalIsOpen}
            setIsOpen={setModalIsOpen}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            addressMapLocation={addressMapLocation}
          />
        )}
        {modalIsOpen && typeFreight === "withdraw" && (
          <ModalWithdrawal
            isOpen={modalIsOpen}
            setIsOpen={setModalIsOpen}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            stores={stores}
          />
        )}
        {tableModalIsOpen && (
          <ModalTableSave
            isOpen={tableModalIsOpen}
            setIsOpen={setTableModalIsOpen}
            setLoading={setLoading}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
          />
        )}
        {modalEditFreight && (
          <ModalEditFreight
            isOpen={modalEditFreight}
            setIsOpen={setModalEditFreight}
            setLoading={setLoading}
            backgroundButton={
              config?.webappcolor.webappbutton &&
              config.webappcolor.webappbutton
            }
            fontButton={
              config?.webappcolor.fontbutton && config.webappcolor.fontbutton
            }
            typeFreight={typeFreight}
            valueFreight={typeFreight === "withdraw" ? valueWithDraw : valueCep}
            changeValue={
              typeFreight === "withdraw" ? setValueWithDraw : setValueCep
            }
            newValueFreight={setFreightFind}
          />
        )}
      </div>
    </div>
  );
}
